/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col} from "react-bootstrap";


import PAGE_IMAGE_1 from "@Images/wallpaper_1.jpg";
import PAGE_IMAGE_2 from "@Images/wallpaper_2.jpg";


type BlockContentPictureProps = {
    headerPictureType: 1 | 2
};


export const BlockContentPictureComponent: React.FC<BlockContentPictureProps> = ({
    headerPictureType = 1
}): JSX.Element => {


    return (
        <Col xs={12} className={"page-picture-component"}>
            <img src={headerPictureType === 1 ? PAGE_IMAGE_1 : PAGE_IMAGE_2} alt={`Aplikacja eKiosk`} />
        </Col>
    );

};


export default BlockContentPictureComponent;
